export default function(RootController, EventModel) {

  /**
   * EventsController Class
   *
   * @public
   * @class EventsController
   */
  return class EventsController extends RootController {

    /**
     * EventsController constructor
     *
     * @public
     * @constructor
     * @param {Object} options - Options
     */
    constructor(options = {}) {
      super(Object.assign({}, {
        name: 'events'
      }, options))
    }

    /**
     * Create new event
     *
     * @public
     * @param {Object} req - Express req
     * @param {Object} res - Express res
     */
    create(req, res) {

      const event = new EventModel()
      const time = new Date().toISOString()

      let pkg = Object.assign({}, req.body, {
        ip        : req.ip,
        origin    : (req.get('Origin')) ? req.get('Origin').replace(/^https?:\/\//, '') : '',
        referrer  : req.get('Referrer'),
        time,
        useragent : req.get('User-Agent')
      })

      return event.create(pkg)

    }

    /**
     * Delete an event by id
     *
     * @public
     * @param {Object} req - Express req
     * @param {Object} res - Express res
     */
    deleteById(req, res) {

      var event = new EventModel()

      return event.deleteById(req.params.id)

    }

    /**
     * Get event by id
     *
     * @public
     * @param {Object} req - Express req
     * @param {Object} res - Express res
     */
    getById(req, res) {

      const event = new EventModel()

      return event.getById(req.params.id)

    }

    /**
     * Get all events
     *
     * @public
     * @param {Object} req - Express req
     * @param {Object} res - Express res
     */
    getAll(req, res) {

      const event = new EventModel()

      return event.getAll()

    }

    /**
     * Update a event
     *
     * @public
     * @param {Object} req - Express req
     * @param {Object} res - Express res
     */
    updateById(req, res) {

      const event = new EventModel()

      return event.updateById(req.params.id, req.body)

    }


  }

}
